<template>
  <div class="m-content">
    <h6>Copyright © <a style="color:#20a0ff" href="https://github.com/wuzhenxi520?tab=stars" target="_blank">JesseWu</a></h6>
    <h6><a style="color:#20a0ff" href="https://beian.miit.gov.cn/" target="_blank">鄂ICP备2021021927号</a></h6>
  </div>
</template>

<script>
  export default {
    name: "Footer",
    data() {
      return {
        
      }
    },
    methods: {
      
    },
    // created() {
      
    // }
  }
</script>

<style scoped>

  .m-content {
    max-width: 960px;
    margin: 0 auto;
    text-align: center;
  }

</style>